import React from "react";
import {
  createShouldForwardProp,
  props,
} from "@styled-system/should-forward-prop";
import { styled, EmotionComponent } from "../../styled";
import {
  textStyle,
  position,
  color,
  typography,
  space,
  layout,
  border,
  compose,
  system,
  PositionProps,
  TextStyleProps,
  ColorProps,
  TypographyProps,
  SpaceProps,
  LayoutProps,
  BorderProps,
  textTransformProp,
  TextTransformProp,
  textDecorationProp,
  TextDecorationProp,
  OverrideNativeElementProps,
} from "../../utils/styleFn";

const customProps = system({
  whiteSpace: true,
  textOverflow: true,
  textDecoration: true,
});

const styleProps = compose(
  position,
  color,
  typography,
  space,
  layout,
  border,
  customProps
);

export type TextProps = OverrideNativeElementProps<
  TextDecorationProp &
    TextTransformProp &
    PositionProps &
    TextStyleProps &
    ColorProps &
    TypographyProps &
    SpaceProps &
    LayoutProps &
    BorderProps & {
      whiteSpace?: string;
      textOverflow?: string;
      textDecoration?: string;
    },
  "p"
>;

const shouldForwardProp = createShouldForwardProp([...props, "textTransform"]);

export const Text: EmotionComponent<TextProps> = styled("p", {
  shouldForwardProp,
})`
  ${textStyle}
  ${styleProps}
  ${textTransformProp}
  ${textDecorationProp}
`;

Text.displayName = "Text";

Text.defaultProps = {
  textStyle: "text",
};

export type SpanProps = TextProps &
  React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLParagraphElement>,
    HTMLSpanElement
  >;

export const Span: EmotionComponent<SpanProps> = Text.withComponent(
  "span"
) as any;

Span.displayName = "Span";

Span.defaultProps = {
  textStyle: "text",
};

export default Text;
